// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.agreementOptions {
  margin-inline-start: 40%;
  margin-top: 30px;
}
.agreementNoticeIcon {
  text-align: center;
  margin-top: 80px;
}
.agreementNotice {
  display: flex;
  justify-content: center;
}
.agreementTitle {
  display: flex;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/app/Views/Security/UpdateAgreement.less"],"names":[],"mappings":"AAGA;EACE,wBAAA;EACA,gBAAA;AAFF;AAKA;EACE,kBAAA;EACA,gBAAA;AAHF;AAMA;EACE,aAAA;EACA,uBAAA;AAJF;AAOA;EACE,aAAA;EACA,uBAAA;AALF","sourcesContent":["@import '~common-controls/Style/Colors.less';\n\n\n.agreementOptions {\n  margin-inline-start: 40%;\n  margin-top: 30px;\n}\n\n.agreementNoticeIcon {\n  text-align: center;\n  margin-top: 80px;\n}\n\n.agreementNotice {\n  display: flex;\n  justify-content: center;\n}\n\n.agreementTitle {\n  display: flex;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
